// extracted by css-extract-rspack-plugin
export default {"content":"JMFB_B7dsohZ6hes","field":"BJ8giFyv_SM1oOXZ","fieldLabel":"Wk4OVlMWq4ge5uU9","hiddenFooterRoot":"S6N4DbB0qHgJlebF"};